<template>
  <div class="title-box">
    <el-checkbox v-model="complete" @change="finishTask" style="margin-right:6px;"></el-checkbox>
    <div v-if="!isEdit" class="task-title-wrap ellipsis hover-style" :class="{'hover-style-rest':readonly}" style="flex: 1" @click="editTitle">
      <div v-show="isSub && taskInfo.msgcount > 0" class="task-badge"></div>
      <div class="task-title ellipsis" :title="taskInfo.title">{{taskInfo.title}}</div>
    </div>
    <div class="task-title" v-else>
      <el-input style="width: 100%" ref="inputs" size="small" v-model="taskInfo.title" @blur="blur" @change="change"></el-input>
    </div>
    <el-dropdown @command="handleCommand" size="small" trigger="click">
      <i class="icon iconfont iconicon_more_task1"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="del">删除</el-dropdown-item>
        <div v-if="taskInfo.parent_id == 0">
          <el-dropdown-item command="cancel_attention" v-if="taskInfo.is_attention">取消关注</el-dropdown-item>
          <el-dropdown-item command="add_attention" v-else>关注</el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import followApi from '@/services/api/follow/follow'
export default {
  name: "TaskTitle",
  props: {
    taskInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isSub: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      oldTitle: '',
      complete: false
    }
  },
  watch: {
    taskInfo: {
      handler: function (val) {
        this.taskInfo.status === 2 ? this.complete = true : this.complete = false
      },
      immediate: true
    }
  },
  computed: {
    isFinish() {
      return this.taskInfo.status === 2 ? true : false;
    }
  },
  methods: {
    ...mapActions('task/task', ['editTask', 'delTask']),
    finishTask($event) {
      // $event.stopPropagation()
      // 如果是完成状态,点击无效
      // 发送完成任务请求,临时改变状态,如果失败切回原来的状态
      let oldVal = this.complete;
      let newVal = this.complete ? 2 : 1
      this.taskInfo.status = newVal
      this.editTask({
        task_id: this.taskInfo.task_id,
        status: newVal
      }).then(res => {
        // 这里需要派发通知,如果是列表页面需要通知列表中的数据改变状态
        this.$emit("success")
      }).catch(() => {
        this.complete = oldVal
      })
    },
    editTitle() {
      // TODO:这里可以做本地鉴权, 执行人, 项目管理员
      this.isEdit = true;
      this.oldTitle = this.taskInfo.title;
      this.$nextTick(() => {
        this.$refs["inputs"].focus();
      });
    },
    change() {
      this.isEdit = false;
      this.editTask({
        task_id: this.taskInfo.task_id,
        title: this.taskInfo.title
      }).then(res => {
        // 这里需要派发通知,如果是列表页面需要通知列表中的数据改变状态
        this.$emit("success")
      }).catch(() => {
        this.taskInfo.title = this.oldTitle
      })
    },
    blur() {
      this.isEdit = false;
    },
    async deletedTask($event) {
      // $event.stopPropagation()
      // 删除任务
      await this.$wfAlert('warning', `确认需要删除该任务?`)
      await this.delTask({
        task_id: this.taskInfo.task_id
      })
      this.$emit("delSuccess")
    },
    handleCommand(type) {
      if (type === 'del') {
        this.deletedTask()
      }
      if (type === 'cancel_attention' || type === 'add_attention') {
        this.isFollow(type)
      }
    },
    isFollow(action) {
      followApi.subscriptionTask({ task_id: this.taskInfo.id }).then(res => {
        this.$emit('success')
      })
    },
  }
}
</script>

<style scoped lang="scss">
.title-box {
  display: flex;
  align-items: center;
  align-content: center;
  font-size: 14px;
  color: initial;
  padding: 0;
}
.title-box .task-title {
  flex: 1;
  font-size: 14px;
}
.title-box i {
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;
}
.check-box {
  position: relative;
  cursor: pointer;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #f5f9fe;
  border: 2px solid rgba(25, 24, 67, 0.2);
  margin-right: 16px;
  box-sizing: border-box;
}
.check-box.active {
  background-color: #00b97e;
  border-color: #00b97e;
}
.check-box.active::after {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  content: "";
  width: 3px;
  height: 9px;
  border: 1px solid #ffffff;
  border-width: 2px;
  position: absolute;
  top: 1px;
  left: 5px;
  transform-origin: center;
  transform: rotate(45deg);
  left: 4px;
  top: -1px;
  border-left: 0;
  border-top: 0;
  transition: transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s,
    -webkit-transform 0.15s ease-in 0.05s;
}
</style>
